import React, { Component } from 'react';
import {
  Route,
  Switch,
  NavLink
} from 'react-router-dom';
import { connect } from 'react-redux';

import './ValidatorIndex.scss';

import {
  getCurrentMeet
} from 'selectors';

import ConnectionChecker from './ConnectionChecker';
import DatabaseChecker from './DatabaseChecker';
import SetupChecker from './SetupChecker';

class ValidatorIndex extends Component {

  render() {
    const { meet } = this.props;
    if(!meet) {
      return null;
    }

    const baseUrl = `/meets/${meet._id}`;

    return (
      <div className="validator-index">
        <div className="tabs">
          <NavLink to={`${baseUrl}/validator/connectionChecker`} className="tab" activeClassName='active'>Connection</NavLink>
          <NavLink to={`${baseUrl}/validator/databaseChecker`} className="tab" activeClassName='active'>Database Integrity</NavLink>
          <NavLink to={`${baseUrl}/validator/setupChecker`} className="tab" activeClassName='active'>Data Setup</NavLink>
        </div>

        <Switch>

          <Route path='/meets/:meetId/validator/connectionChecker' component={ConnectionChecker} />
          <Route path='/meets/:meetId/validator/databaseChecker' component={DatabaseChecker} />
          <Route path='/meets/:meetId/validator/setupChecker' component={SetupChecker} />
        </Switch>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    meet: getCurrentMeet(state, props)
  };
};

const actions = {};

export default connect(mapStateToProps, actions)(ValidatorIndex);
